// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { useOpenedIncomingPayment } from '@tectonics/prs/incoming-payment';
import { useCurrentAllFeatures } from '@tectonics/prs/payment-spec';
import { hasFeature } from '@tectonics/prs/feature';
import {
  getWithholdTaxes as getWithholdTaxesParams,
  formatWithholdTaxesInstructionTextCertificate,
} from '@tectonics/prs/argentina/withhold-taxes';

export function TextInstructionWithholdTaxesByCustomer(): Node {
  const incomingPayment = useOpenedIncomingPayment();
  const currentAllFeatures = useCurrentAllFeatures();

  if (!hasFeature(currentAllFeatures, 'instruction_text_certificate_withhold_taxes')) {
    return null;
  }

  const withholdTaxesParams = getWithholdTaxesParams(incomingPayment, '');
  const instructionTextCertificate = formatWithholdTaxesInstructionTextCertificate(withholdTaxesParams);

  return (
    <InstructionText>
      {instructionTextCertificate}
    </InstructionText>
  );
}

const InstructionText = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  font-size: 0.9em;
`;
